import React, { useReducer } from "react";
import PostContext from "./postContext";
import postReducer from "./postReducer";
import { API_BASE, apiErrorMessage, authedFetch } from "../../utils/api";

import {
  GET_POSTS,
  ADD_POST,
  DELETE_POST,
  POST_ERROR,
  CLEAR_POSTS,
  FAVORITE_POST,
  ADD_POST_COMPLETE,
  CLEAR_POST_MESSAGES,
} from "../types";

const PostState = (props) => {
  const initialState = {
    posts: [],
    loading: true,
    postAdded: false,
    message: null,
  };

  const [state, dispatch] = useReducer(postReducer, initialState);

  // Get Contacts
  const getPosts = async (tags) => {
    var url = `${API_BASE}/posts`;
    if (tags) {
      url += `?tags=${tags}`;
    }
    const res = await authedFetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const res_json = await res.json();
    if (res.ok) {
      dispatch({ type: GET_POSTS, payload: res_json });
    } else {
      var error_msg = null;
      if (res.status === 401) {
        error_msg = "Unauthorized";
      } else {
        error_msg = apiErrorMessage(res_json);
      }
      dispatch({ type: POST_ERROR, payload: error_msg });
    }
  };

  const addPost = async (post) => {
    const formData = new FormData();
    const tags = post.tags ? post.tags.map((tag) => tag.name) : [];
    const tagStr = tags.join(",");
    formData.append("content", post.content);
    formData.append("title", post.title);
    formData.append("owner", post.owner);
    formData.append("cover_photo", post.cover_photo);
    formData.append("description", post.description);
    formData.append("tags", tagStr);
    const res = await authedFetch(`${API_BASE}/post`, {
      method: "POST",
      body: formData,
    });
    const res_json = await res.json();
    if (res.ok) {
      dispatch({ type: ADD_POST, payload: res_json });
    } else {
      dispatch({ type: POST_ERROR, payload: apiErrorMessage(res_json) });
    }
  };

  const deletePost = async (id) => {
    const res = await authedFetch(`${API_BASE}/post/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const res_json = await res.json();
    if (res.ok) {
      dispatch({ type: DELETE_POST, payload: id });
    } else {
      var error_msg = null;
      if (res.status === 401) {
        error_msg = "Unauthorized";
      } else {
        error_msg = apiErrorMessage(res_json);
      }
      dispatch({ type: POST_ERROR, payload: error_msg });
    }
  };

  const favoritePost = async (id, is_favorite) => {
    const formData = new FormData();
    formData.append("is_favorite", is_favorite);
    const res = await authedFetch(`${API_BASE}/favorite_post/${id}`, {
      method: "POST",
      body: formData,
    });
    const res_json = await res.json();
    if (res.ok) {
      dispatch({ type: FAVORITE_POST, payload: res_json });
    } else {
      var error_msg = null;
      if (res.status === 401) {
        error_msg = "Unauthorized";
      } else {
        error_msg = apiErrorMessage(res_json);
      }
      dispatch({ type: POST_ERROR, payload: error_msg });
    }
  };

  const clearPosts = () => {
    dispatch({ type: CLEAR_POSTS });
  };

  const clearPostMessages = () => {
    dispatch({ type: CLEAR_POST_MESSAGES });
  };

  const addPostComplete = () => {
    dispatch({ type: ADD_POST_COMPLETE });
  };

  return (
    <PostContext.Provider
      value={{
        posts: state.posts,
        loading: state.loading,
        postAdded: state.postAdded,
        message: state.message,
        getPosts,
        addPost,
        deletePost,
        clearPosts,
        clearPostMessages,
        favoritePost,
        addPostComplete,
      }}
    >
      {props.children}
    </PostContext.Provider>
  );
};

export default PostState;
